import Modal from "components/Modal/Modal";
import Text from "components/Text/Text";
import React from "react";
import styles from "./SalesModal.module.scss";
import cx from "classnames";
import Select from "components/Input/InputSelect/InputSelect";
import Input from "components/Input/Textarea/Textarea";
import Button from "components/Button/Button";


interface ISalesModal {
  isOpen: boolean;
  handleClose: () => void;
}

const SalesModal: React.FC<ISalesModal> = ({
  isOpen,
  handleClose
}) => {
 return(
  <Modal
    handleClose={handleClose} 
    isOpen={isOpen}
  >

  <div className={styles.wrapper}>
    <div className={styles.header}><Text type="smallHeader">Practitioner Profile</Text></div>
    <div className={styles.container}>   
      <div className={cx(styles.column, styles.item1)}>
        <Text bold type="secondary">Practitioner Name:</Text>
        <Text bold textAlign="right">Pedro Freitas</Text>
      </div>
      <div className={cx(styles.column, styles.item9)}>
        <Text bold type="secondary">Priority:</Text>
        <div style={{width:'175px'}}><Select/></div>
      </div>
      <div className={cx(styles.column, styles.item2)}>
        <Text bold type="secondary">Revenue Delta:</Text>
        <Text bold type="currency" textAlign="right">19240</Text>
      </div>
      <div className={cx(styles.column, styles.item5)}>
        <Text bold type="secondary">Distributor Revenue Delta (Zipcode):</Text>
        <Text bold type="currency" textAlign="right">200000</Text>
      </div>
      <div className={cx(styles.column, styles.item3)}>
        <Text bold type="secondary">Revenue Last Twelve Months (LTM):</Text>
        <Text bold type="currency" textAlign="right">200000</Text>
      </div>
      <div className={cx(styles.column, styles.item6)}>
        <Text bold type="secondary">Distributor Revenue LTM:</Text>
        <Text bold type="currency" textAlign="right">200000</Text>
      </div>
      <div className={cx(styles.column, styles.item4)}>
        <Text bold type="secondary">Revenue Prior LTM:</Text>
        <Text bold type="currency" textAlign="right">200000</Text>
      </div>
      <div className={cx(styles.column, styles.item8)}>
        <Text bold type="secondary">Distributor Revenue Prior LTM:</Text>
        <Text bold type="currency" textAlign="right">200000</Text>
      </div>
    </div>
     <div className={cx(styles.notesWrapper, styles.item9)}>
        <Text bold type="secondary">Notes:</Text>
        <Input placeholder="Notes"/>
        <div className={cx( styles.item11, styles.saveBtnWrapper)}>
          <Button type="tertiary" width="100%">SAVE</Button>
        </div>
      </div>
  </div>
  </Modal>
 ) 
}

export default SalesModal;